var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00043 1.81377C5.0375 1.81377 1.81377 5.0375 1.81377 9.00043C1.81377 12.9634 5.0375 16.1871 9.00043 16.1871C12.9634 16.1871 16.1871 12.9634 16.1871 9.00043C16.1871 5.0375 12.9634 1.81377 9.00043 1.81377ZM9.00043 16.7782C4.71177 16.7782 1.22266 13.2891 1.22266 9.00043C1.22266 4.71177 4.71177 1.22266 9.00043 1.22266C13.2891 1.22266 16.7782 4.71177 16.7782 9.00043C16.7782 13.2891 13.2891 16.7782 9.00043 16.7782Z",
    fill: "#A30F28",
    stroke: "#A30F28",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43977 8.99986L12.0198 6.41982C12.1415 6.29817 12.1415 6.10155 12.0198 5.97991C11.8982 5.85826 11.7015 5.85826 11.5799 5.97991L8.99986 8.55995L6.41982 5.97991C6.29817 5.85826 6.10155 5.85826 5.97991 5.97991C5.85826 6.10155 5.85826 6.29817 5.97991 6.41982L8.55995 8.99986L5.97991 11.5799C5.85826 11.7015 5.85826 11.8982 5.97991 12.0198C6.04057 12.0805 6.12022 12.111 6.19986 12.111C6.27951 12.111 6.35915 12.0805 6.41982 12.0198L8.99986 9.43977L11.5799 12.0198C11.6406 12.0805 11.7202 12.111 11.7999 12.111C11.8795 12.111 11.9591 12.0805 12.0198 12.0198C12.1415 11.8982 12.1415 11.7015 12.0198 11.5799L9.43977 8.99986Z",
    fill: "#A30F28",
    stroke: "#A30F28",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/RedAlert.022a9dd3cbe64de5ea0b4466963f06b2.svg";
export { ForwardRef as ReactComponent };